/* Keeps the PDP blank-apparel free-shipping card in step with the cart.
 *
 * The cart drawer and cart page render their copies server side, so they are always correct.
 * The PDP copy is rendered once with the cart total at page load, so after an add-to-cart it
 * would sit stale until the next navigation. This re-reads /cart.js and repaints it.
 *
 * Blanks are identified by vendor: on this store 'Ninja Transfers' is exactly the 2,212
 * Collective blanks (everything else is 'DTFTransfers'), and /cart.js carries `vendor` per
 * line, so no Section Rendering round trip is needed. Product tags are NOT in /cart.js, which
 * is why the vendor test and not a tag test.
 *
 * Bar width is left to window.reCalculateFreeShippingModule__recall in component-cart.js,
 * which already paints every <free-shipping-blanks> on the page.
 */
(function () {
  'use strict';
  if (window.__dtfBlanksFreeship) return;
  window.__dtfBlanksFreeship = true;

  var VENDOR = 'Ninja Transfers';

  function usd(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  function cards() {
    return document.querySelectorAll('.fs-card--bfs-pdp');
  }

  function paint(totalCents) {
    var list = cards();
    for (var i = 0; i < list.length; i++) {
      var card = list[i];
      var el = card.querySelector('free-shipping-blanks');
      if (!el) continue;
      var threshold = parseFloat(el.getAttribute('free-shipping-amount')) || 0;
      el.setAttribute('data-cart-total', totalCents);

      var body = card.querySelector('.fs-card__body');
      if (body && threshold) {
        var remaining = Math.max(0, threshold - totalCents);
        body.innerHTML = remaining > 0
          ? 'Add <strong class="fs-card__amount">' + usd(remaining) + '</strong> for <strong>free shipping</strong>'
          : '<strong>Free shipping</strong> unlocked';
        /* is-unlocked lets the blank PDP turn the card green (snippets/blanks-pdp-top.liquid);
           the Liquid sets the same class on first paint. (Justin 2026-09-23) */
        card.classList.toggle('is-unlocked', remaining === 0);
      }
    }
    if (typeof window.reCalculateFreeShippingModule__recall === 'function') {
      window.reCalculateFreeShippingModule__recall();
    }
  }

  var inflight = false;
  function refresh() {
    if (inflight || !cards().length || typeof fetch !== 'function') return;
    inflight = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        inflight = false;
        if (!cart || !cart.items) return;
        var total = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (it.vendor === VENDOR) total += (it.final_line_price || 0);
        }
        paint(total);
      })
      .catch(function () { inflight = false; });
  }

  /* Debounced: a single add fires several DOM mutations as the drawer rebuilds. */
  var t = null;
  function schedule() {
    if (t) clearTimeout(t);
    t = setTimeout(refresh, 400);
  }

  function start() {
    refresh();
    if ('MutationObserver' in window) {
      var forms = document.querySelectorAll('cart-form');
      for (var i = 0; i < forms.length; i++) {
        new MutationObserver(function (muts) {
          for (var j = 0; j < muts.length; j++) {
            if (muts[j].type === 'childList') { schedule(); return; }
          }
        }).observe(forms[i], { childList: true, subtree: true });
      }
    }
    /* Add-to-cart submissions that do not rebuild a drawer still change the cart. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.getAttribute && (form.getAttribute('action') || '').indexOf('/cart/add') > -1) {
        setTimeout(refresh, 900);
        setTimeout(refresh, 2200);
      }
    }, true);
    /* Coming back to the tab after checking out in another one. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) schedule();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
